// src/components/TSRList.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

function TSRList() {
  const navigate = useNavigate();

  const tsrItems = [
    {
      title: "Велотренажер Манупед (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=265",
      img: "https://cszn.info/Files/rental-tsr/velotrenazher_dlya_vosstanovle.67dbe0fff27b0.jpg"
    },
    {
      title: "Иппотренажер Takasima S-Rider SKY 007 (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=267",
      img: "https://cszn.info/Files/rental-tsr/ippotrenazher.67dbe2c83acfc.jpg"
    },
    {
      title: "Вертикализатор (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=298",
      img: "https://cszn.info/Files/rental-tsr/vertikalizator.67dbf728030accopy1.jpg"
    },
    {
      title: "Вертикализатор (для участников СВО) копия",
      link: "https://cszn.info/public/rental-tech-equipment?view=299",
      img: "https://cszn.info/Files/rental-tsr/vertikalizator.67dbf728030accopy2.jpg"
    },
    {
      title: "КАПИТАН 1.1 (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=263",
      img: "https://cszn.info/Files/rental-tsr/kapitan_1.1.67dbdebfd855f.jpg"
    },
    {
      title: "КАПИТАН 1.2 (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=262",
      img: "https://cszn.info/Files/rental-tsr/kapitan_1.2_s_velotrenazherom.67dbdd8d3bdc9.jpg"
    },
    {
      title: "Тренажер для разработки голеностопного сустава (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=266",
      img: "https://cszn.info/Files/rental-tsr/trenazher_dlya_razrabotki_gole.67dbe1c4c17b4.jpg"
    },
    {
      title: "Тренажерный комплекс для лежачих больных (для участников СВО)",
      link: "https://cszn.info/public/rental-tech-equipment?view=264",
      img: "https://cszn.info/Files/rental-tsr/trenazhernui_kompleks_dlya_lez.67dbe008398f3.jpg"
    }
  ];

  return (
    <div className="container payouts-list position-relative py-5 show">
      <div className="back-arrow-circle" onClick={() => navigate('/')}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
        </svg>
      </div>

      <h2 className="text-center mb-5 fw-bold text-primary">
        Средства реабилитации для участников СВО      </h2>

      <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 g-4 justify-content-center">
        {tsrItems.map((item, index) => (
          <div key={index} className="col">
            <div className="card h-100 shadow-sm border-0 text-center hover-lift transition-all">
              <div className="position-relative overflow-hidden bg-light" style={{ height: '180px' }}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: 'cover' }}
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=Нет+фото'; }}
                />
              </div>
              <div className="card-body d-flex flex-column p-3">
                <h6 className="card-title small mb-3 flex-grow-1">{item.title}</h6>
                <a 
                  href={item.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-primary btn-sm mt-auto"
                >
                  Наличие в пункте проката
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Кнопка "Посмотреть все" */}
      <div className="text-center mt-5">
        <a 
          href="https://cszn.info/public/rental-tech-equipment" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn btn-outline-primary btn-lg px-5"
        >
          Посмотреть все ТСР
        </a>
      </div>
    </div>
  );
}

export default TSRList;